import { render, staticRenderFns } from "./HrDocumentPreviousVersion.vue?vue&type=template&id=22289278&scoped=true&"
import script from "./HrDocumentPreviousVersion.vue?vue&type=script&lang=js&"
export * from "./HrDocumentPreviousVersion.vue?vue&type=script&lang=js&"
import style0 from "./HrDocumentPreviousVersion.vue?vue&type=style&index=0&id=22289278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22289278",
  null
  
)

export default component.exports